import React, { useState } from "react";
import ctl from "@netlify/classnames-template-literals";
import { Link } from "gatsby";
import { Container, PLink, Text } from "components";
import Arrow from "svgs/chevron-right.svg";
import PrimaryArrow from "svgs/cta-arrow.svg";
import { Solutions } from "config/menu/solutions";

const SubMenu = ({ items, menuOpen }) => {
  const SolutionsValues = Object.values(Solutions);
  const [activeSubMenu, setActiveSubMenu] = useState(0);

  const handleSubSwitch = id => {
    if (activeSubMenu !== id && window.innerWidth < 900) {
      setActiveSubMenu(id);
    } else if (window.innerWidth > 900) {
      setActiveSubMenu(id);
    } else {
      setActiveSubMenu(null);
    }
  };

  return (
    <div className={`${subMenuStyle} ${menuOpen ? "block" : "hidden"} `}>
      {items.length > 3 ? (
        <div className={solutionsWrapper}>
          <aside className={solutionsMenu}>
            <ul className={solutionsMenuList}>
              {SolutionsValues.map((item, i) => {
                return (
                  <li className={menuList} key={i}>
                    <button
                      className={`${menuToggle} ${
                        activeSubMenu === i ? currentList : ""
                      }`}
                      onClick={() => handleSubSwitch(i)}
                    >
                      {item.product}
                      <Arrow
                        className={`${
                          activeSubMenu === i
                            ? "stroke-primary max-[768px]:rotate-90"
                            : "stroke-[#666]"
                        }`}
                      />
                    </button>
                    <div
                      className={`${solutionContent} ${
                        activeSubMenu === i ? "block" : "hidden"
                      }`}
                    >
                      <Text
                        value={item.brief}
                        variant="p16"
                        className={leadingText}
                      />
                      <div className="grid md:grid-cols-3 gap-4">
                        {item.features.map(item => {
                          return (
                            <div>
                              <div className={subMenuTitleStyleSolution}>
                                <div className={titleStyleInner}>
                                  <span className={solutionWrapper}>
                                    {item.icon}
                                  </span>
                                  <Text
                                    variant="p16"
                                    value={item.title}
                                    weight="700"
                                  />
                                </div>
                                <Text
                                  variant="p16"
                                  value={item.about}
                                  weight="400"
                                  className={contentHeight}
                                />
                                {item.hasOwnProperty("url") && (
                                  <Link className={goToPage} href={item.url}>
                                    View more
                                  </Link>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className={menuCTAs}>
                        {item.isExternal ? (
                          <a
                            className={learnMore}
                            href={item.productLink}
                            target="_blank"
                            rel="noopenner noreferrer"
                          >
                            Learn more
                            <PrimaryArrow />
                          </a>
                        ) : (
                          <Link
                            className={learnMore}
                            to={`${item.productLink}`}
                          >
                            Learn more
                            <PrimaryArrow />
                          </Link>
                        )}

                        <div className={otherLinks}>
                          {item.appLink ? (
                            <div className={appStoreLinks}>
                              <a href={`${item.appLink[0].appStore}`}>
                                {item.appLink[0].icon}
                              </a>

                              <a href={`${item.appLink[1].playStore}`}>
                                {item.appLink[1].icon}
                              </a>
                            </div>
                          ) : item.externalURL ? (
                            <a
                              href={`${item.externalURL}`}
                              className={internalLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.externalTitle}
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </aside>

          {/* <div className={solutionContent}>
            <Text 
              value="Create your fintech innovations with a partner that provides a secure and robust API infrastructure to scale with." 
              variant="p18"
              className={leadingText}
            />
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <PLink href="#">
                  <div className={subMenuTitleStyle}>
                    <span className={iconWrapperStyle}>

                    </span>
                    <Text variant="p16" value="E-wallets" weight="400" />
                  </div>
                </PLink>
              </div>
            </div>
          </div> */}
        </div>
      ) : (
        <Container>
          <div className="my-5">
            <div className="grid md:grid-cols-3 gap-4">
              {items.map((item, i) => {
                return (
                  <div key={i}>
                    <PLink {...item}>
                      <div className={subMenuTitleStyle}>
                        <span className={iconWrapperStyle}>{item.icon}</span>
                        <Text variant="p16" value={item.title} weight="400" />
                      </div>
                    </PLink>
                  </div>
                );
              })}
            </div>
          </div>
        </Container>
      )}
    </div>
  );
};

const subMenuStyle = ctl(`
  lg:group-hover:block
  lg:hover:block
  lg:absolute
  lg:hidden
  z-10
  lg:mt-5
  w-full
  left-0
  bg-secondary-100
  text-secondary
`);

const subMenuTitleStyle = ctl(` 
  lg:p-4
  flex
  items-center
  md:ml-0
  -ml-6
`);

const iconWrapperStyle = ctl(`
md:inline-flex
flex
items-center
justify-center
bg-secondary
w-[45px]
h-[45px]
rounded-full
mr-4
`);

const solutionWrapper = ctl(`
md:inline-flex
flex
items-center
justify-center
bg-secondary
w-[35px]
h-[35px]
rounded-full
mr-4
`);

const solutionsWrapper = ctl(`
  max-w-[1512px] 
  mx-auto 
  lg:px-6 
  px-4 
  gap-[10px]
`);

const solutionsMenu = ctl(`
  md:bg-[#FBFBFB]
  relative
  flex
  md:pl-[10px]
`);

const solutionsMenuList = ctl(`
  flex
  flex-col
  py-12
  min-[769px]:pb-[300px]
  max-[901px]:w-full
`);

const menuList = ctl(`
  mb-5
  pb-[15px]
  flex
  max-[900px]:flex-col
`);

const menuToggle = ctl(`
  flex
  justify-between
  w-[200px]
  max-[900px]:w-full
  pl-[10px]
  py-[8px]
  max-[768px]:text-[14px]
`);

const currentList = ctl(`
  text-primary
  border-solid
  border-[1px]
  border-[#dddddd]
  rounded
`);

const solutionContent = ctl(`
  min-[900px]:left-[210px]
  min-[900px]:absolute
  right-0
  top-0
  bottom-0
  ml-[10px]
  bg-[#FFFFFF]
  pt-[30px]
  lg:pb-11
  pb-8
`);

const leadingText = ctl(`
  md:mt-[-1px]
  mt-[10px]
  mb-[30px]
  lg:px-4
`);

const subMenuTitleStyleSolution = ctl(`
  lg:p-4
  flex-col
  items-center
  md:ml-0
  h-full
`);

const titleStyleInner = ctl(`
  flex
  mb-[20px]
`);

const menuCTAs = ctl(`
  flex
  max-[515px]:flex-col
  justify-between
  mt-[40px]
  pb-[100px]
  max-[1023px]:px-0
  px-4
`);

const goToPage = ctl(`
  flex
  gap-[8px]
  items-center
  max-[515px]:mb-8
  text-primary
  pt-[10px]
`);

const learnMore = ctl(`
  flex
  gap-[8px]
  items-center
  max-[515px]:mb-8
`);

const otherLinks = ctl(`

`);

const internalLink = ctl(`
  text-primary
  flex
  items-center
  gap-[8px]
  rounded-full
  justify-center
  p-[15px]
  border-solid
  border-[1px]
  border-[#c6c6c6]
`);

const appStoreLinks = ctl(`
  flex
  gap-[15px]
  max-[376px]:flex-col
`);

const contentHeight = ctl(`
  min-[1200px]:min-h-[68%]
  min-[900px]:min-h-[78%]
`);
export { SubMenu };
